import { parseEnv, type Env } from '@bp-files/client';

/**
 * The validated environment.
 *
 * **The schema lives in `@bp-files/client`; the evaluation lives here**, and
 * that split is the seam rather than an accident of the extraction. `parseEnv`
 * is a pure function of a record, so the package can test every validation rule
 * without Vite's env plumbing — while `import.meta.env` is a Vite-only global
 * that only an app has. Moving this line down into the package would drag that
 * plumbing with it and make the package's own test run depend on a bundler.
 *
 * Evaluated at module load: importing this module in a misconfigured app throws
 * immediately, which is the intent. `vite build` bundles it without evaluating
 * it, so a misconfigured build succeeds and fails on first page load with a
 * message naming every missing variable.
 *
 * **Never read `import.meta.env` directly** — go through `env` from this
 * module. Adding a variable is two steps in one PR: extend the schema in
 * `@bp-files/client`, and add a placeholder with its prose to
 * `apps/web/.env.example`.
 */
export const env: Env = parseEnv(import.meta.env, 'apps/web');

export type { Env };
